import { http } from '../api/client';

export const tagService = {
    getTags: async ({ queryParams }) => http.get('/tags', { params: queryParams }),
    getTagsAll: async () => http.get('/tags/all'),
    createTag: async (data) => http.post('/tags/create', data),
    updateTag: async (id, data) => http.post(`/tags/edit/${id}`, data),
    deleteTag: async (id) => http.post(`/tags/delete/${id}`),
}